import { Outlet } from 'react-router-dom';

export default function ClaimsLayout() {
  return (
    <div className="h-full bg-gray-50 dark:bg-gray-900 overflow-hidden">
      <Outlet />
    </div>
  );
}
